import { render, staticRenderFns } from "./SalaryDetails.vue?vue&type=template&id=fe6ad368&scoped=true"
import script from "./SalaryDetails.vue?vue&type=script&lang=js"
export * from "./SalaryDetails.vue?vue&type=script&lang=js"
import style0 from "./SalaryDetails.vue?vue&type=style&index=0&id=fe6ad368&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe6ad368",
  null
  
)

export default component.exports